import React from "react";
import { UxSizeEnum } from "@imaginelearning/mps-ux-component-library";
import EdgeBackButton from "../edge-back-button/edge-back-button";
import useBreakpoint from "../liftoff/hooks/useBreakpoint";
import "./small-screen-subheader.scss";

export interface SmallScreenSubheaderProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  onBackClick?: (() => void);
}

function SmallScreenSubheader({ left, right, children, className = "", onBackClick }: SmallScreenSubheaderProps) {
  const { isSmallScreen } = useBreakpoint();

  if (!isSmallScreen) return null;

  return (
    <div className={`small-screen-subheader ${className}`}>
      <div className="small-screen-subheader-left">
        {onBackClick && <EdgeBackButton iconSize={UxSizeEnum.MEDIUM} onBackClick={onBackClick} />}
        {left}
      </div>
      <div className="small-screen-subheader-center">{children}</div>
      <div className="small-screen-subheader-right">{right}</div>
    </div>
  );
}

export default SmallScreenSubheader;
